// extracted by mini-css-extract-plugin
export default {"panel-left":"panel_panel-left__3TLPE","panel-right":"panel_panel-right__1C3g5","panel-bottom":"panel_panel-bottom__V-fKf"};